var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"negative-container d-flex justify-content-center"},[_c('div',{staticClass:"svg-container"},[_c('object',{staticClass:"svg-obj",attrs:{"data":_vm.svgUrl}}),_c('div',{staticClass:"text-gray-700 text-center my-4"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }